import Heading from 'carbon-react/lib/components/heading';

interface ActionBarTitleProps {
  title?: string;
}
export function ActionBarTitle({ title }: ActionBarTitleProps) {
  return <Heading headingType="h1" title={title} separator={false} divider={false} />;
}
